import prismicService from '@/helpers/prismicService'
import i18n from '@/plugins/i18n'

const state = () => ({
  locales: []
})

const getters = {
  isAvailableLocale: state => state.locales.some(item => item === i18n.locale)
}

const mutations = {
  setLocales(state, locales) {
    state.locales = locales
  }
}

const actions = {
  async getAvailableLocales({ commit, getters }) {
    const document = await prismicService.getAllConfiuredResources()
    const locales = []
    locales.push(document.lang)
    document.alternate_languages.forEach(item => {
      locales.push(item.lang)
    })
    commit('setLocales', locales)
    if (!getters.isAvailableLocale) {
      i18n.locale = 'en-gb'
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
